export default "__VITE_ASSET__CDgklTnq__"